import { encryptTransform } from "redux-persist-transform-encrypt";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import userSlice from "./slices/user.slice";
import deviceSlice from "./slices/device.slice";
import dashboardSlice from "./slices/dashboard.slice";
import themeSlice from "./slices/theme.slice";
import reportSlice from "./slices/report.slice";
import envConfig from "@/config/envConfig";
import { mainApi } from "./mainApi";
import dashboardSliceV2 from "./slices/dashboardV2.slice";
import liveDashboardSlice from "./slices/liveDashboard.slice";

const encryptor = encryptTransform({
  secretKey: envConfig.REDUX_STORAGE_SECRET_KEY,
  onError: function (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  },
});

const persistConfig = (key) => ({
  key,
  storage: storage,
  timeout: null,
  transforms: [encryptor],
});

const rootReducers = combineReducers({
  [userSlice.name]: persistReducer(persistConfig(userSlice.name), userSlice.reducer),
  [deviceSlice.name]: persistReducer(persistConfig(deviceSlice.name), deviceSlice.reducer),
  [reportSlice.name]: persistReducer(persistConfig(reportSlice.name), reportSlice.reducer),
  [dashboardSlice.name]: persistReducer(persistConfig(dashboardSlice.name), dashboardSlice.reducer),
  [dashboardSliceV2.name]: persistReducer(persistConfig(dashboardSliceV2.name), dashboardSliceV2.reducer),
  [liveDashboardSlice.name]: liveDashboardSlice.reducer,
  theme: persistReducer(persistConfig(themeSlice.name), themeSlice.reducer),
  // [dashboardSliceV2.name]: dashboardSliceV2.reducer,
  // theme: themeSlice.reducer,

  // api
  api: mainApi.reducer,
});

// const persistedReducer = persistReducer(persistConfig, userReducer);

export const store = configureStore({
  reducer: rootReducers,
  devTools: envConfig.NODE_ENV === "development",
  // middleware: [thunk],
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(mainApi.middleware),
});
export const persistor = persistStore(store);
